import { Navigate } from 'react-router-dom';

export const PrivateRoute = ({ children, ...rest }) => {
  const token =  sessionStorage.getItem("token");

  return token ? children : <Navigate to='/auth/login' />;
};
